import Passport, {PassportData} from "@/types/clients/esquire/data/general/passport";

export interface IGuestData {
  id: number;
  type?: string;
  gender?: string;
  first_name?: string;
  last_name?: string;
  address?: string;
  zipcode?: string;
  city?: string;
  country?: string;
  email?: string;
  phone?: string;
  language?: string;
  company_name?: string;
  company_vat?: string;
  po_number?: string;
  passport?: PassportData | null;
}

export default class Guest {
  public id: number;
  public type: string;
  public gender: string;
  public firstName: string;
  public lastName: string;
  public address: string;
  public zipcode: string;
  public city: string;
  public country: string;
  public email: string;
  public phone: string;
  public language: string;
  public companyName: string;
  public companyVat: string;
  public poNumber: string;
  public passport: Passport|null;

  constructor(data: IGuestData) {
    this.id = data.id;
    this.type = data.type ?? "";
    this.gender = data.gender ?? "";
    this.firstName = data.first_name ?? "";
    this.lastName = data.last_name ?? "";
    this.address = data.address ?? "";
    this.zipcode = data.zipcode ?? "";
    this.city = data.city ?? "";
    this.country = data.country ?? "";
    this.email = data.email ?? "";
    this.phone = data.phone ?? "";
    this.language = data.language ?? "";
    this.companyName = data.company_name ?? "";
    this.companyVat = data.company_vat ?? "";
    this.poNumber = data.po_number ?? "";
    this.passport = data.passport ? new Passport(data.passport) : null;
  }

  toDTO(): IGuestData {
    return {
      id: this.id,
      type: this.type || undefined,
      gender: this.gender || undefined,
      first_name: this.firstName || undefined,
      last_name: this.lastName || undefined,
      address: this.address || undefined,
      zipcode: this.zipcode || undefined,
      city: this.city || undefined,
      country: this.country || undefined,
      email: this.email || undefined,
      phone: this.phone || undefined,
      language: this.language || undefined,
      company_name: this.companyName || undefined,
      company_vat: this.companyVat || undefined,
      po_number: this.poNumber || undefined,
      passport: this.passport ? this.passport.toDTO() : null
    };
  }

  toJson(): IGuestData {
    return this.toDTO();
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  get fullAddress(): string {
    const parts = [this.address, this.zipcode, this.city].filter(Boolean);
    return parts.join(", ");
  }


}
